module.exports = __webpack_public_path__ + "f6196c35eaa5f89d91622564664ffdc8.pdf";